export class PermissionModel {
	id: string;
	title: string;
	checked = false;
}
